import { useApiClient, useFetchInfiniteES } from '@marageti/z4-lib';
import { Review } from '@marageti/z4-sdk/lib/travel';
import { SearchRequest } from '@marageti/z4-sdk/lib/entity';

const ITEMS_PER_PAGE = 10;

type SearchField = 'partnerId' | 'travelerId' | 'tripMatchId';

interface UseReviewsParams {
  searchItemId: string;
  searchItemFieldName: SearchField;
  itemsPerPage?: number;
}

const useReviews = ({
  searchItemId,
  searchItemFieldName,
  itemsPerPage = ITEMS_PER_PAGE,
}: UseReviewsParams) => {
  const apiClient = useApiClient();

  const searchQuery: SearchRequest | undefined = searchItemId
    ? {
      filterBy: [{ field: searchItemFieldName, value: [searchItemId] }],
      sortBy: [{ field: 'createdAt', order: 'desc' }],
      pagination: { limit: itemsPerPage, page: 1 },
    }
    : undefined;

  const {
    data, error, isValidating, hasMore, loadMore,
  } = useFetchInfiniteES<Review>(apiClient.reviewsClient.postReviewsSearch, searchQuery);

  return {
    reviews: data?.flatMap((page) => page.hits),
    totalReviews: data?.[0]?.totalHits ?? 0,
    loading: isValidating,
    error,
    loadMore,
    hasNextPage: hasMore,
  };
};

export default useReviews;
